import React from 'react'
import { Link } from 'react-router-dom'
import BGImg from "../../assets/img/bg/footer-bg.png";

const Main = () => {
  return (
    <>
        <footer className="footer-bg footer-p">
            <div className="footer-top  pt-90 pb-40" style={{background_color: "#644222", backgroundImage: `url(${BGImg})`}}>
                <div className="container">
                    <div className="row justify-content-between">                          
                        <div className="col-xl-4 col-lg-4 col-sm-6">
                            <div className="footer-widget mb-30">
                                <div className="f-widget-title mb-30">
                                   <img src="assets/img/logo/logoHLF.png" alt="img" />
                                </div>
                                <div className="footer-link">
                                   <p>Somos un proyecto nacido de la visión de Hacienda Zotoluca, combinando su riqueza histórica con un enfoque innovador en hospitalidad. Inspirado en la arquitectura y el legado colonial de la hacienda, La Finca rescata sus elementos distintivos y los fusiona con un diseño moderno, creando un espacio único que rinde homenaje a la identidad cultural de la región.</p>
                                </div>
                            </div>
                        </div>
						<div className="col-xl-2 col-lg-2 col-sm-6">
                            <div className="footer-widget mb-30">
                                <div className="f-widget-title">
                                    <h2>Enlaces</h2>
                                </div>
                                <div className="footer-link">
                                    <ul>                                        
                                        <li><Link to="/">Inicio</Link></li>
                                        <li><Link to="/about"> Nosotros</Link></li>
                                        <li><Link to="/room-details-cama-king">Habitaciones </Link></li>
                                        <li><Link to="/service-details"> Servicios </Link></li>
                                        {/* <li><Link to="/gallery">Galería </Link></li> */}
                                        <li><Link to="/contact"> Contacto</Link></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-2 col-lg-2 col-sm-6">
                            <div className="footer-widget mb-30">
                                <div className="f-widget-title">
                                    <h2>Zotoluca</h2>
                                </div>
                                <div className="footer-link">
                                    <ul>
                                        <li><a href="https://haciendazotoluca.com/" target="_blank" rel="noopener noreferrer">Hacienda Zotoluca</a></li>
                                        <li><a href="https://hzmexico.com/" target="_blank" rel="noopener noreferrer">HZ Tienda</a></li>
                                    </ul>
                                </div>
                            </div>
                        </div>  
                        <div className="col-xl-4 col-lg-4 col-sm-6">
                            <div className="footer-widget mb-30">
                                <div className="f-widget-title">
                                  <h2>Contacto</h2>
                                </div>
                                <div className="f-contact">
                                    <ul>
                                        <li>
                                            <i className="icon fal fa-phone"></i>
                                            <span>55 3455 4183<br/>56 6222 3977</span>
                                        </li>
                                        <li>
                                            <i className="icon fal fa-envelope"></i>
                                            <span>
                                                <span>recepcion@lafincahz.com<br/>direccion@lafincahz.com</span>
                                            </span>
                                        </li>
                                        <li>
                                            <i className="icon fal fa-map-marker-check"></i>
                                            <span>Carretera Apan – El Aserradero. Chimalpa, Apan, Hidalgo.</span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="copyright-wrap">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-6 col-md-6">                         
                        &copy; Hotel La Finca por Zotoluca      
                        </div>
                        <div className="col-lg-6 col-md-6 text-right text-xl-right">                       
                           <div className="footer-social">                                    
                                {/* <Link to="#"><i className="fab fa-facebook-f"></i></Link> */}
                                {/* <Link to="#"><i className="fab fa-twitter"></i></Link> */}
                                <a href="https://www.facebook.com/haciendazotoluca/" target="_blank" rel="noopener noreferrer">
                                    <i className="fab fa-facebook-f"></i>
                                </a>
                                <a href="https://www.instagram.com/lafincaporzotoluca/" target="_blank" rel="noopener noreferrer">
                                    <i className="fab fa-instagram"></i>
                                </a>
                            </div>        
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    </>
  )
}

export default Main
